 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML9781607052029_01_TITLE from '@/components/html/9781607052029_01_title'
 import HTML9781607052029_02_COPY from '@/components/html/9781607052029_02_copy'
 import HTML9781607052029_03_ACK from '@/components/html/9781607052029_03_ack'
 import HTML9781607052029_04_DED from '@/components/html/9781607052029_04_ded'
 import HTML9781607052029_05_TOC from '@/components/html/9781607052029_05_toc'
 import HTML9781607052029_06_INTRO from '@/components/html/9781607052029_06_intro'
 import HTML9781607052029_07_BASIC from '@/components/html/9781607052029_07_basic'
 import HTML9781607052029_08_COLOR from '@/components/html/9781607052029_08_color'
 import HTML9781607052029_09_PRO from '@/components/html/9781607052029_09_pro'
 import HTML9781607052029_10_CHIRIST from '@/components/html/9781607052029_10_chirist'
 import HTML9781607052029_11_THE from '@/components/html/9781607052029_11_the'
 import HTML9781607052029_12_CARIBBEAN from '@/components/html/9781607052029_12_caribbean'
 import HTML9781607052029_13_CIRCULAR from '@/components/html/9781607052029_13_circular'
 import HTML9781607052029_14_ATREAT from '@/components/html/9781607052029_14_atreat'
 import HTML9781607052029_15_THESTOCK from '@/components/html/9781607052029_15_thestock'
 import HTML9781607052029_16_PERKY from '@/components/html/9781607052029_16_perky'
 import HTML9781607052029_17_GENERALQUILT from '@/components/html/9781607052029_17_generalquilt'
 import HTML9781607052029_18_GENERAL from '@/components/html/9781607052029_18_general'
 import HTML9781607052029_19_SPECIAL from '@/components/html/9781607052029_19_special'
 import HTML9781607052029_20_AUTHOR from '@/components/html/9781607052029_20_author'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML9781607052029_21_SOURCE from '@/components/html/9781607052029_21_source'
 import HTML9781607052029_22_COPY1 from '@/components/html/9781607052029_22_copy1'
 import HTML9781607052029_23_THANK from '@/components/html/9781607052029_23_thank'
 import HTML9781607052029_24_BACKCOVER from '@/components/html/9781607052029_24_backcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/9781607052029_05_toc",
 			"name" : "html/9781607052029_05_toc",
 			"component" : HTML9781607052029_05_TOC
 		},
 		{
 			"path" : "/html/9781607052029_06_intro",
 			"name" : "html/9781607052029_06_intro",
 			"component" : HTML9781607052029_06_INTRO
 		},
 		{
 			"path" : "/html/9781607052029_07_basic",
 			"name" : "html/9781607052029_07_basic",
 			"component" : HTML9781607052029_07_BASIC
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js